import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";

const certs = [
  { code: "ISO 13485", label: "Medical Device Quality Management" },
  { code: "ISO 10993", label: "Biocompatibility Certified" },
  { code: "CE MARK", label: "European Conformity" },
  { code: "GMP", label: "Good Manufacturing Practice" },
];

const tests = [
  "Cytotoxicity (ISO 10993-5) — Pass",
  "Skin Sensitisation (ISO 10993-10) — Pass",
  "Antimicrobial Efficacy (ASTM E2315) — 99.9%",
  "Dermal Irritation Study — Non-Irritant",
  "Wound Closure Efficacy Trial — Verified",
  "Shelf-Life Stability (24 months) — Confirmed",
];

export const Certification = () => (
  <section id="certification" className="py-24 md:py-32 bg-primary relative overflow-hidden" data-testid="certification-section">
    <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_20%_20%,#EBB850,transparent_45%)]" />
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 relative z-10">
      <div className="flex items-baseline gap-4 mb-12">
        <span className="font-serifaccent italic text-secondary text-6xl md:text-7xl leading-none">03</span>
        <div>
          <span className="font-monotech text-xs tracking-[0.25em] uppercase text-secondary">Chapter</span>
          <h2 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-white leading-none">
            Tests &amp; Certification
          </h2>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-3xl overflow-hidden mb-8">
        {certs.map((c, i) => (
          <motion.div
            key={c.code}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="bg-primary p-6 md:p-8 hover:bg-accent transition-colors duration-300"
            data-testid={`cert-badge-${i}`}
          >
            <BadgeCheck className="w-7 h-7 text-secondary mb-4" />
            <div className="font-heading font-extrabold text-2xl md:text-3xl text-white tracking-tight">
              {c.code}
            </div>
            <div className="text-white/60 text-sm mt-1.5">{c.label}</div>
          </motion.div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3">
        {tests.map((t, i) => (
          <motion.div
            key={t}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="flex items-center gap-3 border-b border-white/10 py-3.5"
          >
            <span className="font-monotech text-xs text-secondary">{String(i + 1).padStart(2, "0")}</span>
            <span className="text-white/85 text-sm md:text-base font-medium">{t}</span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
